// extracted by mini-css-extract-plugin
module.exports = {"textbox":"search_textbox__27wWF"};